import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { Product } from "../../../domain/entities/product/Product";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { queryKey as getOrderSummaryForCheckout } from "./useGetOrderSummaryForCheckout";

const orderRepo = OrderRepositoryImpl.getInstance();

const useRemoveProductFromCheckout = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: (itemIds: string[]) => {
        return orderRepo.removeItems(auth, itemIds, apiUrl);
      },
      onSuccess: () => {
        queryClient?.invalidateQueries({
          queryKey: [getOrderSummaryForCheckout],
        });
      },
    },
    queryClient,
  );

  const removeProductFromCheckout = useCallback(
    (itemsToRemove: Product[], onSuccess?: () => void, onError?: (error: unknown) => void) => {
      const itemIds = itemsToRemove.map((item) => item.itemId) as string[];

      mutation.mutate(itemIds, { onSuccess, onError });
    },
    [mutation],
  );

  return removeProductFromCheckout;
};

export { useRemoveProductFromCheckout };
